import styled from 'styled-components';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';

export const ModalHomeBtn = styled(Button)`
  width: 32px;
  height: 32px;
`;
